/*
 * Copyright (c) 2024 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

import { AnvilorFormsAppStore } from "../anvilor-forms-app-store.service";
import { AnvilorFormsAppStoreContext } from "../anvilor-forms-app-store.service";
import { AnvilorNotificationsService } from "@anvilor/ngx-apps-core";
import { combineLatest } from "rxjs";
import { tap } from "rxjs";
import { map } from "rxjs/operators";
import { asSignal } from "@anvilor/ngx-core-utils";

export class ValidationLoadingChecks {
  private notify: AnvilorNotificationsService;
  private store: AnvilorFormsAppStore;

  constructor(ctx: AnvilorFormsAppStoreContext) {
    this.store = ctx.store;
    this.notify = ctx.notify;
  }

  watchForInvalidLoad() {
    this.watchForDisallowedAnonymousSubmission();
  }

  private watchForDisallowedAnonymousSubmission() {
    const isMakingDisallowedSubmission$ = combineLatest([
      this.store.isAnonymousSubmission$,
      this.store.disabledAnonymousSubmissions$,
    ]).pipe(map(([isAnon, anonDisallowed]) => isAnon && anonDisallowed));

    const notification$ = isMakingDisallowedSubmission$.pipe(
      asSignal(),
      tap(() =>
        this.notify.error.active(
          {
            error_code: "ANONYMOUS_SUBMISSIONS_DISALLOWED",
            title: "Anonymous Submissions Not Supported",
            body:
              "Anonymous submissions are not supported for this link. Please " +
              "ensure you have visited the correct link.",
          },
          { disableClose: true }
        )
      )
    );

    this.store.subscribeTo(notification$);
  }
}
